import api from '../api';
import commentsRealtime from '../solicitation/comments.realtime.service';
import EventEmmiter from '../../../providers/event.emmiter';

const events = new EventEmmiter();
const pendingReads = new Map();

const find = () => api.get({ type: 'user', service: 'request-comment-notifications' })
    .then(response => {
        if (response.data?.success !== true || !Array.isArray(response.data.value))
            throw new Error('Invalid request comment notifications response');
        return response.data.value;
    });
const read = id => {
    const key = `${id}`;
    if (pendingReads.has(key)) return pendingReads.get(key);

    const operation = api.put({ type: 'user', service: `request-comment-notifications/${id}` })
        .then(response => {
            if (response.data?.success !== true)
                throw new Error('Failed to mark request comment notification as read');
            events.emmit('onRead', id);
            return response;
        })
        .finally(() => pendingReads.delete(key));
    pendingReads.set(key, operation);
    return operation;
};

const readComments = async commentIds => {
    const ids = new Set(commentIds.map(id => `${id}`));
    if (!ids.size) return;

    const notifications = await find();
    const visible = notifications.filter(notification =>
        ids.has(`${notification.additionalData?.requestCommentId}`)
    );
    await Promise.all(visible.map(notification => read(notification.id)));
};

const subscribe = onChange => {
    events.on('onRead', onChange);
    const unsubscribe = commentsRealtime.subscribe({ onConnect: onChange, onChange });
    return () => {
        events.removeListener('onRead', onChange);
        unsubscribe();
    };
};

const customerCommentNotificationService = { find, read, readComments, subscribe };
export default customerCommentNotificationService;
